export const IMAGES_BASE_PATH = "https://m.media-amazon.com";

export const IMAGES = {
  OOPS: `${IMAGES_BASE_PATH}/images/G/01/CosmosWeb/VirtualCallboxGuest/location-unknown.png`,
  OOPS_404: `${IMAGES_BASE_PATH}/images/G/01/CosmosWeb/VirtualCallboxGuest/oops-404.png`,
};
